import { Carousel } from 'react-responsive-carousel';
import React, { useMemo } from 'react';
import { MobileProfileCarouselStyled } from "./styled/MobileProfileCarouselStyled";
import _ from 'lodash';

function MobileProfileCarousel(props) {
    const {children} = props;

    const parsedChildren = useMemo(() => Array.isArray(children)
            ? children.filter(elem => !!elem)
            : children
                ? [children]
                : [],
        [children]);

    if (_.isEmpty(parsedChildren)) {
        return null;
    }

    return <MobileProfileCarouselStyled>
        <Carousel
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            showIndicators={parsedChildren.length > 1}
        >
            {parsedChildren.map(elem => React.cloneElement(elem, {allowClose: parsedChildren.length === 1}))}
        </Carousel>
    </MobileProfileCarouselStyled>
}

export default MobileProfileCarousel;
